/* Calculadora "¿Cuántos metros necesito?" + infografía que se desliza en celular.
   Recomienda la oferta de 15 m o la de 25 m. Los botones "Elegir la de X m" los atiende manguera-ofertas.js.
   Datos que lee del HTML (se editan desde la sección de Shopify): data-whatsapp (solo números) y data-whatsapp-text. */
(function () {
  'use strict';
  if (window.__mgCalc) return;
  window.__mgCalc = true;
  var form = document.getElementById('mg-calc-form');
  if (form) {
    var number = (form.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
    var message = form.getAttribute('data-whatsapp-text') || 'Hola! Quiero consultar por la manguera de riego (15 m / 25 m).';
    var WHATSAPP = number ? 'https://wa.me/' + number + '?text=' + encodeURIComponent(message) : '';
    var input = document.getElementById('mg-input');
    var label = document.getElementById('mg-input-label');
    var result = document.getElementById('mg-result');
    var modes = form.querySelectorAll('input[name="mg-mode"]');
    var labelD = form.getAttribute('data-label-distance') || 'Distancia desde la canilla hasta el punto más lejano (metros)';
    var labelM = form.getAttribute('data-label-area') || 'Superficie del jardín (m²)';
    var emptyText = form.getAttribute('data-empty-text') || 'Ingresá un valor para ver qué largo te conviene.';

    var mode = function () {
      var m = 'd';
      Array.prototype.forEach.call(modes, function (r) { if (r.checked) m = r.value; });
      return m;
    };
    var fmt = function (n) { return (Math.round(n * 10) / 10).toString().replace('.', ','); };
    var pick = function (offer, txt) { return '<br><button type="button" class="button mg-pick" data-pick-offer="' + offer + '">' + txt + '</button>'; };

    var render = function () {
      var m = mode();
      label.textContent = m === 'd' ? labelD : labelM;
      input.placeholder = m === 'd' ? 'Ej: 18' : 'Ej: 150';
      var v = parseFloat(String(input.value).replace(',', '.'));
      result.className = 'mg-calc__result';
      if (!(v > 0)) { result.textContent = emptyText; return; }
      // Con m² se estima el peor caso: terreno cuadrado y canilla en una esquina (la diagonal).
      var d = m === 'd' ? v : Math.sqrt(2 * v);
      var detail = m === 'm' ? ' (distancia estimada al punto más lejano: ' + fmt(d) + ' m)' : '';
      var wa = WHATSAPP ? '<br><a class="button" href="' + WHATSAPP + '" target="_blank" rel="noopener">Consultar por WhatsApp</a>' : '';
      if (d <= 12) {
        result.className += ' is-ok';
        result.innerHTML = '<strong>Te alcanza con el rollo de 15 metros</strong>Llegás al punto más lejano con margen para curvas y obstáculos.' + detail + pick('15', 'Elegir la de 15 m');
      } else if (d <= 15) {
        result.className += ' is-tight';
        result.innerHTML = '<strong>La de 15 m llega justo: te conviene la de 25 m</strong>Con curvas o desniveles la de 15 m podría quedarte corta. La de 25 m además trae el porta manguera de regalo.' + detail + pick('25', 'Elegir la de 25 m');
      } else if (d <= 20) {
        result.className += ' is-ok';
        result.innerHTML = '<strong>Te alcanza con el rollo de 25 metros</strong>Llegás con margen para curvas y obstáculos, y se lleva el porta manguera de regalo.' + detail + pick('25', 'Elegir la de 25 m');
      } else if (d <= 25) {
        result.className += ' is-tight';
        result.innerHTML = '<strong>La de 25 m te alcanza justo</strong>La distancia entra en 25 metros, pero si hay curvas o desniveles podría quedarte corta.' + detail + pick('25', 'Elegir la de 25 m');
      } else {
        result.className += ' is-short';
        result.innerHTML = '<strong>Ni la de 25 metros alcanza</strong>Escribinos por WhatsApp y te asesoramos.' + detail + wa;
      }
    };

    input.addEventListener('input', render);
    Array.prototype.forEach.call(modes, function (r) { r.addEventListener('change', render); });
    render();
  }

  /* Infografía: en celular se ve grande y se desliza de costado; arranca centrada en los carteles de metros */
  var fig = document.querySelector('.mg-infografia--full');
  if (fig) {
    var hint = document.querySelector('.mg-pan-hint');
    var center = function () {
      if (fig.scrollWidth <= fig.clientWidth + 4) return;
      fig.scrollLeft = Math.round(fig.scrollWidth * 0.46 - fig.clientWidth / 2);
    };
    center();
    window.addEventListener('load', center);
    window.addEventListener('resize', center);
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      fig.addEventListener(ev, function () { if (hint) hint.classList.add('is-gone'); }, { once: true, passive: true });
    });
  }
})();
